
import { useTranslation } from 'react-i18next';

interface GrilledFishProps {
  onAddToCart: (fish: any) => void;
}

const grilledFishProducts = [
  {
    id: 'gf5',
    nameKey: 'products.barGrilled',
    descKey: 'products.barGrilledDesc',
    price: 4500,
    unit: 'pièce',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/2a2558491e0c8093bc36f6c7a654bbe3.jpeg',
    locations: ['Makepe BM', 'Makepe derrière afriland rond Poulenc'],
    deliveryZones: ['Douala 5ème']
  },
  {
    id: 'gf1',
    nameKey: 'products.capitaineGrilled',
    descKey: 'products.capitaineGrilledDesc',
    price: 1000,
    unit: 'pièce',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/a248562d23d27321578aaab6090ad725.jpeg',
    locations: ['Makepe BM', 'Makepe derrière afriland rond Poulenc'],
    deliveryZones: ['Douala 5ème']
  },
  {
    id: 'gf3',
    nameKey: 'products.carpeGrilled',
    descKey: 'products.carpeGrilledDesc',
    price: 3500,
    unit: 'pièce',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/06570abdba424455814f4d004b5d3127.jpeg',
    locations: ['Makepe BM', 'Makepe derrière afriland rond Poulenc'],
    deliveryZones: ['Douala 5ème']
  },
  {
    id: 'gf2',
    nameKey: 'products.machoironGrilled',
    descKey: 'products.machoironGrilledDesc',
    price: 4500,
    unit: 'pièce',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/bfeab5170f91a7c22e2c9cfc0bd88bd3.jpeg',
    locations: ['Makepe BM', 'Makepe derrière afriland rond Poulenc'],
    deliveryZones: ['Douala 5ème']
  },
  {
    id: 'gf6',
    nameKey: 'products.maquereauGrilled',
    descKey: 'products.maquereauGrilledDesc',
    price: 2500,
    unit: 'pièce',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/4126659c26eeb9d3a1c1e8276aed13d0.jpeg',
    locations: ['Makepe BM', 'Makepe derrière afriland rond Poulenc'],
    deliveryZones: ['Douala 5ème']
  },
  {
    id: 'gf7',
    nameKey: 'products.silureGrilled',
    descKey: 'products.silureGrilledDesc',
    price: 3500,
    unit: 'pièce',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/50a6fbd77b9d7c0a344f52b903274e11.jpeg',
    locations: ['Makepe BM', 'Makepe derrière afriland rond Poulenc'],
    deliveryZones: ['Douala 5ème']
  },
  {
    id: 'gf4',
    nameKey: 'products.soleGrilled',
    descKey: 'products.soleGrilledDesc',
    price: 6000,
    unit: 'pièce',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/9ced573e75c945b631d84dbdd1f0f7f3.jpeg',
    locations: ['Makepe BM', 'Makepe derrière afriland rond Poulenc'],
    deliveryZones: ['Douala 5ème']
  },
  {
    id: 'gf8',
    nameKey: 'products.brochette',
    descKey: 'products.brochetteDesc',
    price: 200,
    unit: 'pièce',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/ac973389da6299d656368f593f0ae095.jpeg',
    locations: ['Makepe BM', 'Makepe derrière afriland rond Poulenc'],
    deliveryZones: ['Douala 5ème']
  }
];

export default function GrilledFish({ onAddToCart }: GrilledFishProps) {
  const { t } = useTranslation('common');

  return (
    <section id="grilled" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            {t('grilledFish.title')}
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4 mb-4">
            {t('grilledFish.description')}
          </p>
          <div className="text-sm sm:text-base md:text-lg font-medium text-teal-700 max-w-3xl mx-auto px-4">
            <p className="mb-3">{t('grilledFish.deliveryInfo')}</p>
            <p className="mb-3">{t('grilledFish.salesPoints')}</p>
            <p className="mb-3">{t('grilledFish.deliveryZones')}</p>
            <div className="mt-4 bg-orange-50 border border-orange-200 rounded-xl p-4 inline-block">
              <p className="font-semibold text-orange-800 mb-2">🍽️ {t('grilledFish.accompaniments')}</p>
              <p className="text-orange-700">{t('grilledFish.accompanimentsList')}</p>
            </div>
            <div className="mt-4 bg-teal-50 border border-teal-200 rounded-xl p-4 inline-block">
              <p className="font-semibold text-teal-800 mb-2">🎉 {t('grilledFish.eventService')}</p>
              <p className="text-teal-700">{t('grilledFish.eventDescription')}</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 md:gap-8" data-product-shop>
          {grilledFishProducts.map((fish) => (
            <div key={fish.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow border border-gray-100">
              <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden">
                <img 
                  src={fish.image} 
                  alt={t(fish.nameKey)}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-3 sm:top-4 right-3 sm:right-4 bg-orange-600 text-white px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-semibold">
                  {t('grilledFish.grilled')}
                </div>
              </div>
              <div className="p-4 sm:p-5 md:p-6">
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-2">{t(fish.nameKey)}</h3>
                <p className="text-gray-600 text-xs sm:text-sm mb-3 sm:mb-4 line-clamp-2">{t(fish.descKey)}</p>
                <div className="flex items-center justify-between mb-3 sm:mb-4">
                  <div className="min-w-0">
                    <span className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-orange-600 break-words">
                      {fish.price.toLocaleString()}
                    </span>
                    <span className="text-gray-600 text-xs sm:text-sm ml-1">{t('freshFish.perPiece')}</span>
                  </div>
                </div>
                <button
                  onClick={() => onAddToCart({ ...fish, name: t(fish.nameKey) })}
                  className="w-full bg-orange-600 text-white py-2.5 sm:py-3 rounded-full text-xs sm:text-sm md:text-base font-semibold hover:bg-orange-700 transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-shopping-cart-line"></i>
                  {t('grilledFish.addToCart')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
